<!--
  Angular 15 here, so *ngIf / *ngFor throughout — the @if block syntax used in
  the web app does not exist before Angular 17.
-->
<div class="dl-pagination" *ngIf="totalPages > 1" [class.is-loading]="loading">

  <p class="dl-pagination__summary">
    Showing {{ from }}–{{ to }} of {{ totalElements }} {{ itemLabel }}
  </p>

  <div class="dl-pagination__controls">
    <button
      type="button"
      class="dl-btn dl-btn--sm dl-pagination__step"
      [disabled]="!hasPrevious || loading"
      (click)="previous()"
      aria-label="Previous page">
      <mat-icon>chevron_left</mat-icon>
      <span class="dl-pagination__step-label">Prev</span>
    </button>

    <!-- Desktop: a windowed run of page numbers. -->
    <div class="dl-pagination__pages">
      <ng-container *ngFor="let slot of slots; trackBy: trackBySlot">
        <span *ngIf="slot === null" class="dl-pagination__gap" aria-hidden="true">…</span>
        <button
          *ngIf="slot !== null"
          type="button"
          class="dl-btn dl-btn--sm dl-pagination__page"
          [class.is-current]="slot === currentPage"
          [attr.aria-current]="slot === currentPage ? 'page' : null"
          [disabled]="loading"
          (click)="go(slot)">
          {{ slot + 1 }}
        </button>
      </ng-container>
    </div>

    <!-- Phone: the run never fits, so say where you are instead. -->
    <p class="dl-pagination__position">Page {{ currentPage + 1 }} of {{ totalPages }}</p>

    <button
      type="button"
      class="dl-btn dl-btn--sm dl-pagination__step"
      [disabled]="!hasNext || loading"
      (click)="next()"
      aria-label="Next page">
      <span class="dl-pagination__step-label">Next</span>
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>
</div>
